import React from "react";

import styled from "styled-components";
import { Flex, Box } from "reflexbox/styled-components";
import { NavLink } from "react-router-dom";

import { useApplicationStateValue } from "../application/Application";
import TitleSeparator from "../components/title-separator/TitleSeparator";
import { strings } from "../languages/Localize";
import routes from "../config/routes";
import RenderIf from "../common/conditions/RenderIf";
import { checkIfIOS } from "../util/util";

const StyledContainer = styled(Flex)`
    width: 100%;
    height: 100%;
    flex-direction: column;
`;

const StyledSpeakerContainer = styled(Flex)`
    flex-direction: row;
    padding: 16px 16px 0 16px;
`;

const StyledProfileImageContainer = styled(Box)`
    flex: 3;
    height: 20vw;
`;

const StyledProfileImage = styled.img`
    object-fit: cover;
    object-position: top;
    height: 20vw;
    width: 20vw;
    border-radius: 15px;
`;

const StyledDataContainer = styled(Flex)`
    flex: 8;
    flex-direction: column;
    line-height: 15px;
    margin-left: 8px;
`;

const StyledName = styled(Box)`
    width: 100%;
    font-weight: ${({ theme }) => theme.fontWeights.semiBold};
    color: ${({ theme }) => theme.colors.white};
`;

const StyledTitle = styled(StyledName)`
    font-weight: ${({ theme }) => theme.fontWeights.semiLight};
    font-style: italic;
`;

const StyledPanelsContainer = styled(Flex)`
    flex-direction: column;
    padding: 8px 16px 0 16px;

    > :last-child {
        padding-bottom: 50px;
    }
`;

const StyledPanel = styled(Flex)`
    flex-direction: column;
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.primary};
    border-radius: 6px;
    padding: 10px;
    margin: 4px 0 4px 0;
`;

const StyledText = styled(Box)`
    color: ${({ theme }) => theme.colors.white};
    padding: 8px 16px 0 16px;
`;

const StyledLink = styled(NavLink)`
    display: block;
    width: 100%;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.white};
    &:hover,
    &:active {
        color: ${({ theme }) => theme.colors.white};
    }
`;

const DivWithScrollY = styled.div`
    overflow-y: auto;
`;

const Speaker = props => {
    const {
        appData: { forumSpeakers, forumPanels }
    } = useApplicationStateValue();
    const speakerId = props.match && props.match.params && props.match.params.id;
    const currentForumSpeaker = forumSpeakers[speakerId];

    let panels = [];
    if (currentForumSpeaker) {
        [...currentForumSpeaker.panelsAsModerator, ...currentForumSpeaker.panelsAsSpeaker].forEach(panelId => {
            const panel = forumPanels[panelId];
            if (panel) {
                const { label, startTimeLabel, room } = panel;

                let panelLink;
                if (panel.impression?.comment) {
                    panelLink = `${routes.PANELS_IMPRESSION}${panelId}`;
                } else {
                    panelLink = `${routes.PANELS_DETAILS}${panelId}`;
                }

                panels.push(
                    <StyledLink exact to={panelLink} key={panelId}>
                        <StyledPanel paddingX={[1, 2]}>
                            <Box fontSize={[2, 3]} fontWeight="bold" color="primary">
                                {label}
                            </Box>
                            <Box fontSize={[2]} fontWeight="semilight" color="black" opacity={[0.8]}>{`${startTimeLabel}, ${room.toUpperCase()}`}</Box>
                        </StyledPanel>
                    </StyledLink>
                );
            }
        });
    }

    return (
        <StyledContainer>
            <TitleSeparator back>{strings.speakers.HEADER}</TitleSeparator>
            <DivWithScrollY>
                <StyledSpeakerContainer paddingX={[3, 4]} mb={[3, 4]}>
                    <StyledProfileImageContainer>
                        <StyledProfileImage src={currentForumSpeaker.imgUrl} />
                    </StyledProfileImageContainer>
                    <StyledDataContainer marginY={[1, 2]}>
                        <StyledName fontSize={[5]} paddingBottom={[2]}>{currentForumSpeaker.name}</StyledName>
                        <StyledTitle fontSize={[3]}>{currentForumSpeaker.title}</StyledTitle>
                    </StyledDataContainer>
                </StyledSpeakerContainer>
                <StyledText fontSize={[2]}>{currentForumSpeaker.biography}</StyledText>
                <RenderIf
                    render={() => {
                        return <StyledText fontSize={[5]} fontWeight={["semiBold"]}>{strings.panel.HEADER}</StyledText>;
                    }}
                    if={panels.length > 0}></RenderIf>
                <StyledPanelsContainer isios={checkIfIOS() ? 1 : 0}>{panels}</StyledPanelsContainer>
            </DivWithScrollY>
        </StyledContainer>
    );
};

export default Speaker;
